export default "__VITE_ASSET__flrbAsmo__"